import React, { useRef } from 'react';
import { Button, ButtonGroup, CircularProgress } from '@mui/material';
import { Download, Upload } from '@mui/icons-material';

/**
 * Reusable Import/Export Buttons Component
 * @param {Object} props
 * @param {Function} props.onExport - Export handler function
 * @param {Function} props.onImport - Import handler function (receives File object)
 * @param {boolean} props.loading - Loading state
 * @param {boolean} props.disabled - Disabled state
 * @param {string} props.exportLabel - Export button label
 * @param {string} props.importLabel - Import button label
 * @param {string} props.accept - File input accept attribute
 */
const ImportExportButtons = ({
  onExport,
  onImport,
  loading = false,
  disabled = false,
  exportLabel = 'Export CSV',
  importLabel = 'Import CSV',
  accept = '.csv'
}) => {
  const fileInputRef = useRef(null);

  const handleImportClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (file && onImport) {
      onImport(file);
    }
    // Reset input so same file can be selected again
    event.target.value = '';
  };

  return (
    <>
      <ButtonGroup variant="outlined" disabled={disabled || loading}>
        <Button
          startIcon={loading ? <CircularProgress size={16} /> : <Download />}
          onClick={onExport}
          disabled={disabled || loading}
        >
          {exportLabel}
        </Button>
        <Button
          startIcon={<Upload />}
          onClick={handleImportClick}
          disabled={disabled || loading}
        >
          {importLabel}
        </Button>
      </ButtonGroup>
      
      <input
        ref={fileInputRef}
        type="file"
        accept={accept}
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
    </>
  );
};

export default ImportExportButtons;
